export class Address {
  city: string;
  country: string;
  stateProvince: string;
}
